<template>
	<div>
		<!--<template v-if="!isGtsh">
		<el-row class="jbxx-title">
			<span>企业基本信息</span>
			<el-divider></el-divider>
		</el-row>
		<el-row class="entanme-title">
			<span class="entname">{{detail.entname}}</span>
			<br />
			<el-tag type="warning">{{detail.entstatus}}</el-tag>
		</el-row>
		<el-row class="row-content">
			<el-col :span="12">
				统一社会信用代码：{{detail.uniscid}}
			</el-col>
			<el-col :span="12">
				注册号：{{detail.regno}}
			</el-col>
		</el-row>
		<el-row class="row-content">
			<el-col :span="12">
				名称核准号：{{detail.apprno}}
			</el-col>
			<el-col :span="12">
				联系电话：{{detail.tel}}
			</el-col>
		</el-row>
		<el-row class="row-content">
			<el-col :span="12">
				邮政编码：{{detail.postalcode}}
			</el-col>
			<el-col :span="12">
				法定代表人：{{detail.lerep}}
			</el-col>
		</el-row>
		<el-row class="row-content">
			<el-col :span="12">
				注册地址：{{detail.dom}}
			</el-col>
			<el-col :span="12">
				公司类型：{{detail.enttype}}
			</el-col>
		</el-row>
		<el-row class="row-content">
			<el-col :span="8">
				注册资本（万元）：{{detail.regcap}}
			</el-col>
			<el-col :span="8">
				行业门类：{{detail.industryphy}}
			</el-col>
			<el-col :span="8">
				行业代码：{{detail.industryco}}
			</el-col>
		</el-row>
		<el-row class="row-content">

			<el-col :span="8">
				国别：{{detail.country}}
			</el-col>
			<el-col :span="8">
				经营（驻在）期限自：{{detail.opfrom}}
			</el-col>
			<el-col :span="8">
				经营（驻在）期限至：{{detail.opto}}
			</el-col>
		</el-row>

		<el-row class="row-content">
			<el-col :span="8">
				成立日期：{{detail.estdate}}
			</el-col>
			<el-col :span="8">
				核准日期：{{detail.apprdate}}
			</el-col>
			<el-col :span="8">
				登记机关：{{detail.regorg}}
			</el-col>
		</el-row>
		<el-row class="row-content">

			<el-col :span="8">
				管辖机关：{{detail.localorg}}
			</el-col>
			<el-col :span="16">
				属地监管工商所：{{detail.localadm}}
			</el-col>
		</el-row>
		&lt;!&ndash;<el-row class="row-content">
			<el-col :span="8">
				省：{{detail.province}}
			</el-col>
			<el-col :span="8">
				市：{{detail.city}}
			</el-col>
			<el-col :span="8">
				区县：{{detail.county}}
			</el-col>
		</el-row>&ndash;&gt;
		<el-row class="row-content">
			<el-col :span="24">
				经营(业务)范围：{{detail.busscope}}
			</el-col>
		</el-row>
		</template>-->
		<!-- 个体商户基本信息 -->
		<!--<template v-if="isGtsh">
			<el-row class="jbxx-title">
				<span>个体商户基本信息</span>
				<el-divider></el-divider>
			</el-row>
			<el-row class="entanme-title">
				<span class="entname">{{detail.traname}}</span>
				<br />
				<el-tag type="warning">{{detail.compform}}</el-tag>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					统一社会信用代码：{{detail.uniscid}}
				</el-col>
				<el-col :span="12">
					经营者姓名：{{detail.opername}}
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					执照类别：{{detail.blictype}}
				</el-col>
				<el-col :span="12">
					经营场所：{{detail.oploc}}
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					资金数额(万元)：{{detail.capam}}
				</el-col>
				<el-col :span="12">
					经营类别：{{detail.optype}}
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					经营（驻在）期限自：{{detail.opfrom}}
				</el-col>
				<el-col :span="12">
					行业门类：{{detail.industryphy}}
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="8">
					行业代码：{{detail.industryco}}
				</el-col>
				<el-col :span="8">
					行业门类：{{detail.regorg}}
				</el-col>
				<el-col :span="8">
					登记机关：{{detail.industryco}}
				</el-col>
			</el-row>
			<el-row class="row-content">

				<el-col :span="16">
					属地监管工商所：{{detail.localadm}}
				</el-col>
				<el-col :span="8">
					核准日期：{{detail.apprdate}}
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="24">
					经营(业务)范围：{{detail.busscoandform}}
				</el-col>
			</el-row>
		</template>-->
		<el-row class="row-content">
			<el-col :span="24">
				<el-divider/>
				<!--<span style="color: #00afff;font-size: 18px">需要完善信息</span>--><span style="color: #9E9E9E; padding-left: 30px">温馨提示：请完善以下信息，完善信息后可以使用发布、申请、申报、在线咨询等功能；以下信息可多次编辑保存</span>
				<el-divider/>
			</el-col>
		</el-row>
		<el-form ref="form" :model="form" :rules="rules" label-width="110px" label-position="right">
			<el-row class="row-content"  span="24">
				<el-col :span="12">
				<el-form-item label="机构类型" prop="type">
						<!--<el-select v-model="form.lawBusType" placeholder="请选择服务机构类型" clearable size="small">
							<el-option v-for="dict in lawbusTypeOptions" :key="dict.dictValue" :label="dict.dictLabel"
									   :value="dict.dictValue" />
						</el-select>-->
					<el-select v-model="form.type" clearable @change="typeChange">
					  <el-option
					    v-for="item in serviceOrganOptions"
					    :key="item.recid"
					    :label="item.name"
					    :value="item.recid">
					  </el-option>
					</el-select>
				</el-form-item>
				</el-col>
				<el-col  :span="12">
					<el-form-item label="企业网址" prop="website">
						<el-input type="text" v-model="form.website"
								  placeholder="请输入企业网址"
								  />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content"  span="24">
				<el-col :span="12">
					<el-form-item label="联系人" prop="llr">
						<el-input type="text" v-model="form.llr"
								  placeholder="请输入联系人"
						/>
					</el-form-item>
				</el-col>
				<el-col  :span="12">
					<el-form-item label="手机号" prop="llrtel">
						<el-input type="text" v-model="form.llrtel" maxlength="11"
								  placeholder="请输入手机号"
						/>
					</el-form-item>
				</el-col>
			</el-row>
            <el-row class="row-content"  span="24">
                <el-col :span="12">
                    <el-form-item label="联系固话"  :prop="isRequired ? 'llrphone' : ''" :required="isRequired">
                        <el-input type="text" v-model="form.llrphone"
                                  placeholder="请输入联系固话"
                        />
                    </el-form-item>
                </el-col>
                <el-col  :span="12">
                </el-col>
            </el-row>
			<el-row class="row-content">
				<el-form-item label="企业简介" :prop="isRequired ? 'synopsis' : ''" :required="isRequired">
					<el-input type="textarea" v-model="form.synopsis" maxlength="800"
                              show-word-limit
					placeholder="请输入企业简介"
					:autosize="{ minRows: 5, maxRows: 10}"/>
				</el-form-item>
			</el-row>
            <el-row class="row-content">
                <el-col  :span="12">
                    <span style="color: #909399">注：联系人、联系固话对所有用户开放；手机号用于接收平台短信</span>
                </el-col>
            </el-row>

			<el-row class="row-content">
				<el-button type="primary" @click="submitForm()">保存信息</el-button>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import {queryDetail,queryFwjgLx,updateJgfw} from "@/api/qygzs/wsqyjbxx";
	export default {
		name:'waQyxx',
		data(){
			return{
				queryParams:{
					uuid:undefined,
				},
				form:{
					type:undefined,
					llr:undefined,
					llrtel:undefined,
                    llrphone:undefined,
					synopsis:undefined,
					website:undefined,
					recid:undefined,
                    pripid:undefined,
					uuid:undefined,
				},
				detail:{
					
				},
				isGtsh:false,/*是否个体商户，默认为否*/
				isRequired:true,
				serviceOrganOptions:[],
				rules: {
					type:[
					    { required: true, message: '请选择服务机构', trigger: 'change' }
					],
					llrphone:[
					    { required: true, message: '请输入联系固话', trigger: 'blur' }
					],
					synopsis:[
						{ required: true, message: '请输入企业简介', trigger: 'blur' }
					],
                    llr:[
                        { required: true, message: '请输入联系人', trigger: 'blur' }
                    ],
                    llrtel:[
                        { required: true, message: '请输入联系手机号', trigger: 'blur' }
                    ],
				},
				ywFwjgRecid:undefined
			}
		},
		created() {
			this.getDetail();
			this.getFwjgLx();
		},
		methods:{
			typeChange(){
				let type = this.form.type;
				if(type =="b65eab9923a749dea6dd3ab822ea9897"){
					this.isRequired = false;
				}else{
					this.isRequired = true;
				}
			},
			checkPhone(){
				let mobile = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/ // 最新16手机正则
				let value = this.form.llrtel;
				if (value !== null && value !==undefined && value !==''){
					if(!mobile.test(value)){
						this.msgWarning("您输入的手机号格式不正确，请重新输入！");
						return false;
					}else{
						return true;
					}
				}else{
					return true;
				}
			},
			checkTel(){
				let tel =  /(^[0-9]{3,4}\-[0-9]{3,8}$)|(^[0-9]{3,8}$)|(^[0−9]3,4[0-9]{3,8}$)|(^0{0,1}13[0-9]{9}$)/ // 座机
				let value = this.form.llrphone;
				if (value !== null && value !==undefined && value !==''){
					if(!tel.test(value)){
						this.msgWarning("您输入的联系固话格式不正确，请重新输入！");
						return false;
					}else{
						return true;
					}
				}else{
					return true;
				}
			},
			checkSynopsis(){

			},
			getFwjgLx(){
				queryFwjgLx().then(response => {
					// console.log(response);
					this.serviceOrganOptions = response;
				});
			},
			getDetail(){
				//----需要修改为recid
				let ywFwjgRecid = JSON.parse(localStorage.getItem('ssessionLoginUser')).user.ywFwjgRecid;
				this.queryParams.recid =ywFwjgRecid;
				this.loading = true;
				queryDetail(this.queryParams).then(response => {
					// console.log(response)
					this.isGtsh = response.isGtsh;
					this.form.type=response.type;
					this.form.llr=response.llr;
					this.form.llrtel=response.llrtel;
					this.form.synopsis=response.synopsis;
					this.form.website=response.website;
					this.form.recid=response.recid;
					this.form.pripid = response.pripid;
					this.form.llrphone = response.llrphone;
					this.detail=response;
					this.form.uuid=JSON.parse(localStorage.getItem('ssessionLoginUser')).ywFwjg.uuid;
					this.loading = false;
					this.typeChange();
				});
				//----【】需要修改为recid
				this.ywFwjgRecid = JSON.parse(localStorage.getItem('ssessionLoginUser')).user.ywFwjgRecid;
			},
			submitForm() {
				// window.location.reload();
				 if (this.utils.isLoginTimeout()) {
					this.$refs["form"].validate(valid => {
						if(valid && this.checkPhone() && this.checkTel()){
							this.$confirm('是否确认保存当前信息？', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.saveForm();
							})
						}
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
			},
			saveForm(){
				// console.log(this.form)
                updateJgfw(this.form).then(response => {
					if (response.code === 200) {
						let loginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
						console.log("222222222",loginUser);
						let user = loginUser.user;
						user.finishedInfo = 'Y';
						loginUser.user = user;
						user.type=this.form.type;
						let ywFwjg = loginUser.ywFwjg;
						ywFwjg.type = this.form.type;
						loginUser.ywFwjg = ywFwjg;
						localStorage.setItem("ssessionLoginUser",JSON.stringify(loginUser));
                        this.msgSuccess("保存成功");
						this.$emit("update:isQyxxWS",false);
						window.location.reload();
					} else {
						this.msgError(response.msg);
					}
				});
			},
			toOpenPage(topath) {
				this.$router.push({
					path: topath
				})
				this.$store.commit('SET_MAININDEX', topath);
			},
		}
	}
</script>

<style scoped="scoped">
	.jbxx-title{
		color: #409EFF;
		font-size: 1.25rem;
		font-weight: 700;
		margin-bottom: 0.625rem;
		text-align: left;
	}
	.entanme-title{
		background-color: #ebebeb;
		text-align: left;
		min-height: 30px;
		line-height: 1.875rem;
		padding: 0.625rem;
		margin-bottom: 1rem;
	}
	.entname{
		font-size: 18px;
		font-weight: 700;
	}
	.row-content{
		margin-bottom: 1rem;
		text-align: left;
	}
</style>
